<template>
  <div>
    <!-- 主体 -->
    <div class="nav">
      <!-- 表单 -->
      <div class="homeForm">
        <div class="solidBox" v-show="ifShow"></div>
        <el-tabs type="border-card" v-model="activeTab">
          <el-tab-pane label="小组" name="group">
            <!-- 侧边栏 -->
            <div class="group">
              <span @click="open()"><i class="el-icon-plus" />添加组</span>
              <span @click="deleteGroup()"><i class="el-icon-minus" />删除组</span>
              <ul>
                <li @click="clickAll()" :class="activeClass == -1 ? 'active' : ''">
                  <i class="el-icon-school" />全部
                </li>
                <li v-for="(item,index) in groupList"
                  :key=item.groupId
                  @click="selectGroup(item.id,index,item.groupName)"
                  :class="activeClass == index ? 'active' : ''">
                  <i class="el-icon-s-custom" />{{item.groupName}}（{{item.groupWorkerNum}}）
                </li>
              </ul>
            </div>
            <!-- 主体内容 -->
            <div class="group-main">
              <!--用户组成员表格-->
              <div class="searchBox">
                <span class="userName">人员名称</span>
                <el-input placeholder="请输入内容" size="mini" class="inputBox" v-model="key" clearable></el-input>
                <el-button size='mini' type='primary' @click="searchKey"><span style="font-size: 13px">搜索</span></el-button>
              </div>
              <div class="group-header">
                <span class="edit" :hidden="group_operation" @click="checkInput"><i class="el-icon-edit" style="margin-top:8px;"></i></span>
                <span v-if="group_operation">全部成员</span>
                <span v-show="!group_operation && disabledInput" style="margin-top: 8px;">{{newGroupName}}</span>
                <el-input class="groupname" autofocus="true" @blur="blurInput(groupId)" v-show="!group_operation && !disabledInput" v-model="newGroupName"></el-input>
                <el-button v-if="activeClass != -1"
                size="mini" class="addBtn" ghost @click="openAllUser()" :hidden="group_operation"><i class="el-icon-circle-plus" />添加</el-button>
              </div>
              <div class="tableList">
                <el-table :data="tableList" style="width: 100%;" v-loading="loading">
                  <el-table-column label="#" type='index' width="80"></el-table-column>
                  <el-table-column align="center" prop="userName" label="人员名称" >
                  </el-table-column>
                  <el-table-column align="center" prop="createTime" label="创建时间"  >
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="100">
                    <template slot-scope="scope">
                      <el-dropdown trigger="click" placement="bottom">
                      <el-button size="mini">
                      操作
                      <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item><span @click="goMetaData(scope.row)">查看</span></el-dropdown-item>
                        <el-dropdown-item v-if="activeClass != -1"><span @click="deleteGroupUser(scope.row.groupUserId)">移除</span></el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!--分页-->
              <div style="float:right;  margin-top: 30px;" v-if="tableList.length > 0">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNum"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="tableList.length">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="工作人员" name="worker">
            <div class="workerMessage">
              <workerList></workerList>
            </div>
          </el-tab-pane>

        </el-tabs>
      </div>
      <!-- 添加用户组成员弹出框 -->
      <el-dialog title="添加成员" :visible.sync="dialogTableVisible">
        <el-table :data="userNotInGroup" @selection-change="handleSelectionChange" class="dialogTable">
          <el-table-column type="selection"></el-table-column>
          <el-table-column type="index" ></el-table-column>
          <el-table-column property="userName" label="用户名"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogTableVisible = false">取 消</el-button>
          <el-button type="primary" @click="addGroupUser">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import workerList from "./workList";
export default {
  components: { workerList },
	data() {
		return {
      ifShow: true, // 控制左边框是否显示
      active: 1, // 切换tab菜单
      activeTab: 'group',
      // ----------------------------------------------------------------
      disabledInput: true,  // 禁用input框
			activeClass: -1,
      tableList: [],
			pageNum: 1, //当前页码
			pageSize: 10, //默认每页数据量
			totalCount: 10, //总数
			loading: false,
			radio: 1,
			groupList: [],
			userNotInGroup: [],
			groupId: null,
      groupName: "",
      newGroupName: "",
			dialogTableVisible: false,
			multipleSelection: [],
			group_operation:true,//点击全部按钮，相关组操作按钮和删除按钮隐藏
      userName:"",//用户名
      key: '', // 搜索框
      projectId: '',  // 实验id
      idList: '',   // 添加成员的id集合
		};
	},

	created() {
    if (this.$route.query.id) {
      this.projectId = +this.$route.query.id
    } else {
      this.projectId = +this.$store.state.projectId
    }
		this.getGroup();
		this.getUserByGroupId();
	},
	methods: {

    // 点击搜索
    searchKey () {
      if (this.activeClass == -1) {
         this.getUserByGroupId();
      } else {
        this.getUserByGroupId(this.groupId);
      }
    },

    // 点击查看详情
    goMetaData (row) {
      this.$router.push({
        path: '/data/detail',
        query: {
          ringUserId: row.ringUserId,
          name: row.userName
        }
      })
    },

    // 获取所有组
		getGroup() {
      this.loading= true
      this.httpPost("/web/group/v1/searchGroupList",{
        id: this.projectId
      }).then(res => {
        if (res.code == 0) {
          this.loading= false
          this.groupList = res.data

        } else if (res.code == 10001 || res.code == 10002) {
          this.loading= false
          this.$message({
            type: 'error',
            message: res.message
          })
        } else {
          this.loading= false
          this.$message({
            type: 'error',
            message: res.message
          })
        }
			});
    },

    // 新增组
		open() {
			this.$prompt("请输入小组名称", "", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				inputPattern: /^[\u4e00-\u9fa50-9a-zA-Z]{1,10}$/,
        inputErrorMessage:"请输入1-10位字符",
        beforeClose: (action, instance, done) => {
          if (action == 'cancel') {
            done()
          } else if (action == 'confirm') {
            // 添加小组
            this.loading= true
            this.httpPost("/web/group/v1/addGroup", {
              groupName: instance.inputValue,
              projectId: this.projectId
            }).then(res => {
              if (res.code == 0) {
                this.loading= false
                this.$message({
                type: "success",
                message: "添加成功"
              });
              done()
              this.getGroup();
              } else if (res.code == 10001 || res.code == 10002) {
                this.loading= false
                this.$message({
                  type: 'error',
                  message: res.message
                })
              } else {
                this.loading= false
                this.$message({
                  type: 'error',
                  message: res.message
                })
              }
            });
          }
        }
			})
				.then(({ value }) => {
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "取消输入"
					});
				});
    },

    // 点击全部事件
		clickAll() {
      this.key = ''
			this.pageNum = 1;//修改页码
			this.activeClass = -1;
			this.groupId = "";
			this.getUserByGroupId();
			this.group_operation = true;
		},

    // 选中组事件
		selectGroup(groupId, index, groupName) {
      this.pageNum = 1;//修改页码
      this.key = ''
      this.groupId = groupId;
			this.getUserByGroupId(groupId);
			this.groupName = groupName;
			this.newGroupName = groupName;
			this.activeClass = index;
			this.group_operation = false;
		},

    // 删除组
		deleteGroup() {
			if (this.groupId == "") {
				this.$message({
					type: "success",
					message: "请先选中要删除的组"
				});
				return false;
			}
			this.$confirm("此操作将删除组及该组相关实验权限, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
        this.loading= true
				this.httpPost("/web/group/v1/deleteGroup", { id: this.groupId }).then(
					res => {
            if (res.code == 0) {
              this.loading= false
              this.$message({
							type: "success",
							message: "删除成功"
						});
            this.getGroup();
            this.groupId = "";
            this.activeClass = -1
            this.group_operation = true
            this.getUserByGroupId();
            } else if (res.code == 10001 || res.code == 10002) {
              this.loading= false
              this.$message({
                type: 'error',
                message: res.message
              })
            } else {
              this.loading= false
              this.$message({
                type: 'error',
                message: res.message
              })
            }
					}
				);
			})
    },

    // 修改组名
    checkInput () {
      this.disabledInput = !this.disabledInput;
    },
    // 修改组名input输入框失去焦点
    blurInput (id) {
      var new_group = this.newGroupName.trim();
      if (new_group.length > 10) {
        this.$message({
          message: "组名最大长度不能超过10位",
          type: "error"
        })
      } else {
        //修改小组名
        this.loading= true
          this.httpPost("/web/group/v1/updateGroup", {
            groupName: new_group,
            id: id,
            projectId: this.projectId
          }).then(res => {
          if (res.code == 0) {
            this.loading= false
            this.disabledInput = true;
            this.getGroup();
            this.$message({
            message: "修改组名成功！",
            type: "success"
            });
          } else if (res.code == 10001 || res.code == 10002) {
            this.loading= false
            this.$message({
              type: 'error',
              message: res.message
            })
          } else {
            this.loading= false
            this.newGroupName = ''
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        });
      }
    },

    //点击组查询当前组内组员
		getUserByGroupId(groupId) {
      this.loading= true
			this.httpPost("/web/group/v1/searchWorkerList", {
        groupId: groupId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        keywords: this.key,
        projectId: this.projectId,
			}).then(res => {
				if (res.code == 0) {
          this.loading= false
          this.tableList = res.data.data;
					// 上移按钮
					var length = res.data.data.length;
					for(var i = 0; i < length ; i++){
						if (this.tableList[i].userName === this.userName) {
							if(i !=0 ){
								let temp = this.tableList[i]
								for(var j = i-1;j >= 0;j--){
									Vue.set(this.tableList, j + 1, this.tableList[j])
								}
								Vue.set(this.tableList, 0 , temp)
							}
						}
					}
					this.totalCount = res.data.total;
				} else if (res.code == 10001 || res.code == 10002) {
          this.loading= false
            this.$message({
              type: 'error',
              message: res.message
            })
          } else {
            this.loading= false
					this.$message({
						type: "warning",
						message: "查询失败"
					});
				}
			});
    },

    //获取不在当前选中组的用户
		openAllUser() {
			if (this.groupId == "") {
				this.$message({
					type: "info",
					message: "请选择组"
				});
			} else {
        this.dialogTableVisible = true;
        this.loading= true
				this.httpPost("/web/group/v1/searchWorkerListNotInGroup", {
					groupId: this.groupId,
          projectId: this.projectId,
				}).then(res => {
					if (res.code == 0) {
            this.loading= false
            this.userNotInGroup = res.data;
          } else if (res.code == 10001 || res.code == 10002) {
            this.loading= false
            this.$message({
              type: 'error',
              message: res.message
            })
          } else {
            this.loading= false
            this.$message({
              message: "删除用户组成员失败！",
              type: "error"
            });
          }
				});
			}
    },

    //删除用户组成员
		deleteGroupUser(id) {
      this.$confirm("此操作将删除组及该组相关实验权限, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.loading= true
        this.httpPost("/web/group/v1/deleteWorkerFromGroup", { id: id }).then(res => {
          if (res.code == 0) {
            this.loading= false
            this.$message({
              type: "success",
              message: "删除用户组成员成功"
            });
            this.getGroup();
            this.getUserByGroupId(this.groupId);
          } else if (res.code == 10001 || res.code == 10002) {
            this.loading= false
              this.$message({
                type: 'error',
                message: res.message
              })
            } else {
              this.loading= false
              this.$message({
                message: "删除用户组成员失败！",
                type: "error"
              });
            }
          }
        );
      })
    },

    //添加用户组成员
		addGroupUser() {
      this.loading= true
      this.idList = []
      this.multipleSelection.forEach(item => {
        this.idList.push(item.id)
      })
			this.httpPost("/web/group/v1/addWorkerToGroup", {
				workerIdList: this.idList,
        groupId: this.groupId,
			}).then(res => {
        if (res.code == 0) {
          this.loading= false
          this.$message({
					type: "success",
					message: "添加成功"
				});
				this.getGroup();
				this.getUserByGroupId(this.groupId);
				this.dialogTableVisible = false;
      } else if (res.code == 10001 || res.code == 10002) {
        this.loading= false
          this.$message({
            type: 'error',
            message: res.message
          })
        } else {
          this.loading= false
          this.$message({
            message: res.message,
            type: "error"
          });
        }
			});
    },

    //table选中
		handleSelectionChange(val) {
      this.multipleSelection = val;
		},

		//每页显示数据量变更
		handleSizeChange: function(val) {
			this.pageSize = val;
			this.getUserByGroupId(this.groupId);
		},

		//页码变更
		handleCurrentChange: function(val) {
			this.pageNum = val;
			this.getUserByGroupId(this.groupId);
		},
	}
};
</script>

<style scoped>
  .nav >>> .el-table th {
    height: 45px;
    color: #777;
    white-space: nowrap;
    overflow: hidden;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: #59a7ce42 !important;
  }
  .nav >>>.el-dialog__headerbtn {
    position: absolute;
    width: 80px;
    top: 20px;
    right: 20px;
    padding: 0;
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 16px;
    height: 50px;
}
  .searchBox>>>.el-button--mini {
    padding: 5px 15px;
    font-size: 12px;
    border-radius: 3px;
  }
  .homeForm >>> .el-tabs--border-card {
    background: #fff;
    border: 0px solid #dcdfe6;
    -webkit-box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0.12),
      0 0 0px 0 rgba(0, 0, 0, 0.04);
    box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0.12), 0 0 0px 0 rgba(0, 0, 0, 0.04);
  }
  .homeForm >>> .el-tabs--border-card > .el-tabs__content {
    padding: 15px 0;
  }
  .homeForm
    >>> .el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item.is-active {
    color: #409eff;
    border-top: 1px solid #dcdfe6;
    background-color: #fff;
    border-right-color: #dcdfe6;
    border-left-color: #dcdfe6;
  }
  .homeForm>>>.el-tabs--border-card > .el-tabs__header {
  background-color: #F5F7FA;
  border-bottom: 1px solid #E4E7ED;
  border-right: 1px solid #e4e7ed;
  margin: 0;
  }
</style>
<style lang="scss" scoped>
.homeForm {
  border-top: 1px solid #E4E7ED;
  margin: 0px 0 20px;
}
.solidBox {
  position: absolute;
  z-index: 10;
  width: 2px;
  border-left: 1px solid #e4e7ed;
  height: 40px;
}
th{
  background-color: #eee;
}
.bread{
  padding: 5px 0% 20px;
  font-size: 13px;
}
.searchBox{
  margin-bottom: 20px;
  .inputBox{
    width: 20%;
  }
  .userName{
    margin-right: 5px;
  }
  button{
    display: inline-block;
    height: 27px;
  }
}
.main{
  .nav{
    width: 100%;
    padding: 10px 0%;
    overflow: hidden;
    background-color: #fff;
    .addBtn{
      background-color: #ff9800;
      border: 1px solid #ff9800;
      &:focus{
         border: 1px solid #ff9800;
      }
    }
  }
}
.group{
  width: 22%;
  float: left;
  ul{
	height: 600px;
    overflow-y: auto;
    padding-left: 0px;
    margin: 20px 0;
    li{
      padding-left: 15px;
      height: 36px;
      line-height: 36px;
      border: 1px solid #fff;
      margin-bottom: 5px;
      cursor: pointer;
      i{
        vertical-align: middle;
        font-size: 20px;
        color: #ff9800;
        margin-right: 15px;
      }
      &:hover{
        color: #ff9800;
        background-color: #fff5d6;
        border: 1px solid #e1e1e1;
      }
      &.active{
        color: #ff9800;
        background-color: #fff5d6;
        border: 1px solid #e1e1e1;
      }
    }
  }
  span {
    width: 100px;
    height: 30px;
    margin-right: 10px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #e1e1e1;
    display: inline-block;
    cursor: pointer;
    i{
      margin-right: 10px;
    }
  }
}
.group-main{
  margin-left: 3%;
  width: 75%;
  float: left;
  .group-header{
    height: 35px;
    margin-bottom: 10px;
    span{
      float: left;
    }
    button{
      float: right;
      color: #fff;
    }
    i{
      font-size: 16px;
      color: #fff;
      vertical-align: middle;
      margin-right: 5px;
    }
    .groupname{
      border: 0;
      outline: 0;
      width: 150px;
      height: 15px;
      font-size: 13px;
      text-align: left;
      line-height: 15px;
    }
    .edit{
      margin: 0 10px 0 0;
      cursor: pointer;
      i{
        font-size: 20px;
        color: #606266;
      }
    }
  }
  .radio{
    font-size: 12px;
  }
  .tableList{
    .deleteBtn{
	  cursor: pointer;
      display: inline-block;
      width: 50px;
      text-align: center;
      margin-left: 15px;
      i{
        color: #f56c6c;
        vertical-align: middle;
        font-size: 20px;
      }
    }

  }
}
.dialogTable{
	height: 400px;
	overflow-y: auto;
}
button{
	outline:none;
}
</style>





// WEBPACK FOOTER //
// src/components/data/join.vue